import AppRoutes from 'routes/AppRoutes';
import 'styles/index.css';

export default function App() {
  return <AppRoutes />;
}
